import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "currentColor", viewBox: "0 0 17 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.251 8a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75Z" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
